var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.213V22.7511M16 22.7511V18.2891M16 22.7511H11.4062M16 22.7511H20.5938M1.5625 12.5523H30.4375M22.5625 7.4529V2.35352M9.4375 7.4529V2.35352M4.1875 32.9498H27.8125C28.5087 32.9498 29.1764 32.6812 29.6687 32.203C30.1609 31.7249 30.4375 31.0764 30.4375 30.4001V7.4529C30.4375 6.77668 30.1609 6.12816 29.6687 5.65C29.1764 5.17184 28.5087 4.90321 27.8125 4.90321H4.1875C3.49131 4.90321 2.82363 5.17184 2.33134 5.65C1.83906 6.12816 1.5625 6.77668 1.5625 7.4529V30.4001C1.5625 31.0764 1.83906 31.7249 2.33134 32.203C2.82363 32.6812 3.49131 32.9498 4.1875 32.9498Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvent);
export default __webpack_public_path__ + "static/media/icon-event.d1305eb62d56aa4eaf318e0b0ac8140a.svg";
export { ForwardRef as ReactComponent };